import React, { useEffect, useState } from "react";
import analyticsService from "../../services/analytics.service";
import authsService from "../../services/auths.service";
import Googlecharts from "../../components/Googlecharts";
export const data = [
  ["Task", "Hours per Day"],
  ["Jan", 11],
  ["Feb", 101],
];
const Clientstatistics = (props) => {
  const userinfo = authsService.userinfo();

  const [clientoverviewarr, setClientoverviewarr] = useState([]);
  const [clientoverviewdata, setClientoverviewdata] = useState([]);
  const [clienttotalaircon, setClienttotalaircon] = useState([]);
  const [clientmonthwiseusage, setClientmonthwiseusage] = useState([]);
  const [clientmonthwisedata, setClientmonthwisedata] = useState([]);
  const [currentyear, setCurrentyear] = useState(new Date().getFullYear());

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [filterclient, setFilterclient] = useState("");
  //use effects
  useEffect(() => {
    getallClientoverview();
    getallClientmonthwiseoverview();
  }, []);

  //get allclient
  const getallClientoverview = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: userinfo.user_id,
      search: "",
      between: "",
      sort: "",
      group: "client_id",
    };
    return await analyticsService
      .clientAirconoverview(data)
      .then((res) => {
        console.log(res.data.result);
        if (res.data.result) {
          setClientoverviewarr(res.data.result.data);
          setClientoverviewdata(res.data.result.data[0]);
          const data = [
            ["Month", "Total aircon", "Total maintenance", "Total Issue"],
            [
              "Jan",
              res.data.result.data[0].client_total_aircon_unit,
              res.data.result.data[0].client_total_issue,
              res.data.result.data[0].client_total_maintenance,
            ],
          ];
          setClienttotalaircon(data);
        } else {
          setClientoverviewarr([]);
        }
      })
      .catch((err) => {
        setClientoverviewarr([]);
      });
  };
  //get allclient
  const getallClientmonthwiseoverview = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: userinfo.user_id,
      search: "",
      between: "",
      sort: "",
      group: "month_name",
    };
    return await analyticsService
      .clientAirconmonthwiseoverview(data)
      .then((res) => {
        console.log(res.data.result);
        if (res.data.result) {
          setClientmonthwisedata(res.data.result.data);
          const data = [
            ["Month", "maintenance", "issue", "Issue cost"],
            ...res.data.result.data.map((d) => [
              d.month_label,
              Number(d.client_total_maintenance),
              Number(d.client_total_issue),
              Number(d.client_total_issue_cost),
            ]),
          ];

          setClientmonthwiseusage(data);
        } else {
          setClientmonthwiseusage([]);
        }
      })
      .catch((err) => {
        setClientmonthwiseusage([]);
      });
  };
  const selectrandomcolor = () => {
    const colors = [
      "#5EE5FA",
      "#5EC4FA",
      "#5E9EFA",
      "#5E73FA",
      "#5EF1FA",
      "#5EFAE0",
      "#605EFA",
    ];

    const random = Math.floor(Math.random() * colors.length);
    return random, colors[random];
  };
  return (
    <div>
      <div className="d-flex flex-wrap mb-2">
        <div className="flex-fill">
          <h1>Statistics</h1>
        </div>
        <div className="m-1">
          <select
            value={currentyear}
            onChange={(e) => {
              setCurrentyear(e.target.value);
            }}
            className="form-select"
            aria-label="Default select example"
          >
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
          </select>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Googlecharts
            com_data={clientmonthwiseusage}
            chart_type="ColumnChart"
            haxis="Month"
            vaxis="flow"
          />
        </div>
        <div className="col-md-12">
          <div className="bg-white mt-2 table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>month</th>
                  <th style={{ width: 100 }}>Maintenance</th>
                  <th style={{ width: 80 }}>Issue</th>
                  <th style={{ width: 100 }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {clientmonthwisedata ? (
                  <>
                    {clientmonthwisedata.map((monthdata, index) => (
                      <tr className="" key={index}>
                        <td>{monthdata.month_label}</td>
                        {/*      <td>{monthdata.client_total_service}</td> */}
                        <td className="fw-bold text-center">
                          {monthdata.client_total_issue}
                        </td>
                        <td className="fw-bold text-center">
                          {monthdata.client_total_maintenance}
                        </td>
                        <td className="fw-bold text-center">
                          {monthdata.client_total_issue_cost}
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <>0 data available</>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clientstatistics;
